import { Vector2 } from './Vector2';
import { Color4 } from './Color4';

export class EmotionParticleSystemParams {
  public static readonly Default = new EmotionParticleSystemParams();

  public duration: number = -1.0;

  public maxCount: number;

  public emitterPosition: Vector2 = Vector2.Zero;

  public positionVariance: Vector2 = Vector2.Zero;

  public angle: number = 0.0;
  public angleVariance: number = 0.0;

  public lifeTime: number = 0.0;
  public lifeTimeVariance: number = 0.0;

  public emissionRate: number = 0.0;

  public gravity: Vector2 = Vector2.Zero;

  public startRotate: number = 0.0;
  public startRotateVariance: number = 0.0;

  public endRotate: number = 0.0;
  public endRotateVariance: number = 0.0;

  public speed: number = 0.0;
  public speedVariance: number = 0.0;

  public tangentialAccel: number = 0.0;
  public tangentialAccelVariance: number = 0.0;

  public radialAccel: number = 0.0;
  public radialAccelVariance: number = 0.0;

  public startSize: Vector2 = Vector2.Zero;
  public startSizeVariance: Vector2 = Vector2.Zero;

  public endSize: Vector2 = Vector2.Zero;
  public endSizeVariance: Vector2 = Vector2.Zero;

  public startColor: Color4 = Color4.Transparent;
  public startColorVariance: Color4 = Color4.Transparent;

  public endColor: Color4 = Color4.Transparent;
  public endColorVariance: Color4 = Color4.Transparent;

  public startFrame: number = 0.0;
  public startFrameVariance: number = 0.0;

  public frameSpeed: number = 0.0;
  public frameSpeedVariance: number = 0.0;

  public sceneAlpha: number = 1;
}
